<template>
  <div>
    <div class="table">
      <el-table :data="tableData" :empty-text="$t('noData')" style="width: 100%">
        <el-table-column width="180" prop="ctime" label="Invitation Date"></el-table-column>
        <el-table-column prop="nickname" label="User Name"></el-table-column>
        <el-table-column prop="mobile" label="Phone Number"></el-table-column>
        <el-table-column prop="email" label="Email"></el-table-column>

      </el-table>
    </div>

    <Pagination
      v-if="tableData.length>0"
      :totalPage="totalPage"
      :limit="10"
      @changePage="handleCurrentChange"
    ></Pagination>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";

export default {
  components: {
    Pagination
  },
  data() {
    return {
      info: {},
      userInfo: {},
      tableData: [],
      limit: 10,
      page: 1,
      totalPage: 0
    };
  },
  created() {
    this.init();
    this.tableList();
    this.$api.userInfo().then(res => {
      if (res.status) {
        this.userInfo = res.data;
      }
    });

    


  },
  methods: {
    userOrder(val) {
        this.$router.push({
            name: 'stafforder',
            query: {id: val.id}
        })
    },
    handleCurrentChange() {
      this.page += 1;
      this.tableList();
    },
    // 推荐员工列表
    tableList() {
      let data = {
        // id: this.info.id,
        page: this.page,
        limit: this.limit
      };


      this.$api.recommendList(data).then(res => {
        if (res.status) {

          this.tableData = res.data;
          // this.totalPage = Math.ceil(res.data.count / this.limit);
        }
      });


      // let data = {
      //   id: this.info.id,
      //   page: this.page,
      //   limit: this.limit
      // };

      // this.$api.getstafflists(data).then(res => {
      //   if (res.status) {
      //     this.tableData = res.data.data;
      //     this.totalPage = Math.ceil(res.data.count / this.limit);
      //   }
      // });
    },
    init() {
      // 渠道商信息
      this.$api.channelbusinessGetInfo().then(res => {
        if (res.status) {
          this.info = res.data;
          this.tableList();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.money-pannel {
  margin-top: 10px;
  overflow: hidden;
  border: 1px solid #ffccbc;
  border-top: 5px solid #ffccbc;
  padding: 20px 0;
  .money {
    float: left;
    width: 25%;
    border-right: 1px solid #fbe9e7;
    text-align: center;
    margin: -1px;
    font-size: 32px;
    color: #ff5722;
    .nums {
      font-weight: bold;
      float: none;
      margin-left: 0px;
      color: #ff5722;
      font-size: 32px;
      border: 0;
    }
    .title {
      font-weight: normal;
      font-size: 14px;
      color: #666;
      width: 100%;
      display: inline-block;
    }
    .btn {
      width: 170px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: #ff5722;
      color: #fff;
      display: inline-block;
      font-size: 16px;
      border-radius: 4px;
    }
  }
}
</style>